import Vue from 'vue'
import { Message } from 'element-ui'
import Router from 'vue-router'
import store from '../store/store.js'

Vue.use(Router)
import routes from './routesList.js'
// ↓ router
const router = new Router({
	routes,
	// mode: 'history',
});
// ↓ 全局守卫
router.beforeEach((to, from, next) => {
  // to 进入哪个路由
  // from 从哪个路由离开
  // console.log('(beforeEach) to :\n', to)
  // console.log('(beforeEach) from :\n', from)
  // console.log('router.js ↓\nstore.state.logged:', store.state.logged);
  if(to.name == 'LogInPage'){
    next()
  }else if(store.state.logged == 1){
    next()
  }else{
    Message({
      message: '请先登录',
      type: 'warning',
      duration: 4000
    });
    next({ name:  'LogInPage' })
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/router.js